var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSummaryStar = function SvgIconSummaryStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.076 19.818c1.731-1.687.776-4.623-1.617-4.97l-4.52-.656a2.92 2.92 0 0 1-2.197-1.594l-2.02-4.093c-1.07-2.166-4.162-2.166-5.232 0l-2.021 4.093a2.915 2.915 0 0 1-2.197 1.594l-4.52.655c-2.392.348-3.347 3.284-1.617 4.97l3.27 3.187c.687.67 1 1.633.838 2.579l-.772 4.499c-.409 2.38 2.092 4.196 4.232 3.072l4.043-2.123a2.918 2.918 0 0 1 2.714 0l4.043 2.123c2.14 1.124 4.64-.692 4.232-3.072l-.773-4.5a2.912 2.912 0 0 1 .838-2.578l3.27-3.186h.006Z",
    fill: "#FFC82A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.114 20.647a2.729 2.729 0 1 0 0-5.458 2.729 2.729 0 0 0 0 5.458Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.63 26.492h-7.043c-1.031 0-1.746-1.048-1.352-2.002.784-1.901 2.67-3.144 4.874-3.144 2.204 0 4.09 1.243 4.875 3.144.393.955-.321 2.002-1.353 2.002h-.002Z",
    fill: "#FFEEC7"
  })));
};
export default SvgIconSummaryStar;